import { Flame, Sparkles, Star, Trophy } from "lucide-react";
import { progressPercentage } from "@/lib/goals";

const milestones = [
  {
    threshold: 100,
    message: "Parabéns! Meta concluída.",
    icon: Trophy,
    tone: "completion",
  },
  {
    threshold: 90,
    message: "Você está muito perto.",
    icon: Flame,
    tone: "near",
  },
  {
    threshold: 75,
    message: "Falta pouco.",
    icon: Star,
    tone: "near",
  },
  {
    threshold: 50,
    message: "Metade do caminho concluída.",
    icon: Sparkles,
    tone: "middle",
  },
  {
    threshold: 25,
    message: "Um quarto da sua meta já foi.",
    icon: Sparkles,
    tone: "start",
  },
  {
    threshold: 10,
    message: "Você começou. Continue.",
    icon: Flame,
    tone: "start",
  },
];

export const goalMotivation = (goal) => {
  const progress = progressPercentage(goal);
  return milestones.find((milestone) => progress >= milestone.threshold) || null;
};

export const GoalMotivation = ({ goal }) => {
  const milestone = goalMotivation(goal);

  if (!milestone) {
    const hasStarted = goal.marked_count > 0 || goal.saved_cents > 0;
    return (
      <section
        data-testid="motivational-message-banner"
        className="motivation-banner motivation-banner-start"
      >
        <Sparkles className="h-7 w-7 shrink-0" />
        <p>
          {hasStarted
            ? "Seu cofrinho já começou a crescer. Continue."
            : "Seu cofrinho está pronto. Escolha o primeiro valor para começar."}
        </p>
      </section>
    );
  }

  const Icon = milestone.icon;
  return (
    <section
      data-testid="motivational-message-banner"
      data-milestone={milestone.threshold}
      className={`motivation-banner motivation-banner-${milestone.tone}`}
    >
      <Icon className="h-7 w-7 shrink-0" />
      <p>{milestone.message}</p>
    </section>
  );
};